import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaUndo } from "react-icons/fa";

export const ListLoadError = ({
  message,
  onRetry,
  isRetrying = false,
  reset,
}: {
  message: string;
  onRetry?: () => void;
  isRetrying?: boolean;
  reset?: { label: string; onReset: () => void };
}) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" align="center" gap="3" py="10" textAlign="center">
      <Text color="smError">{message}</Text>
      {onRetry && (
        <Button variant="outline" colorScheme="teal" size="sm" onClick={onRetry} isLoading={isRetrying}>
          {t("Try again")}
        </Button>
      )}
      {reset && (
        <Button
          leftIcon={<Icon as={FaUndo} />}
          variant="outline"
          colorScheme="gray"
          color="smMuted"
          size="sm"
          onClick={reset.onReset}
        >
          {reset.label}
        </Button>
      )}
    </Flex>
  );
};
